import React from 'react';
import NodeFoundationFull from './Full';

import { SimpleTeaser } from '../../../components';

const Foundation = (props) => {
  const { entity, viewMode } = props;

  switch (viewMode) {
    case 'teaser':
      return <SimpleTeaser withSummary entity={entity} />;

    default:
      return <NodeFoundationFull entity={entity} />;
  }
};

export default Foundation;
